<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-body card-panel-box border-0">
        <div class="row d-flex justify-content-start">
          <h2 style="font-size: 1.2vw !important;">پايش و اندازه گیری فرآيند</h2>
        </div>

        <div class="table-responsive">
          <center v-show="!all_items.length">
            <p> پایش و اندازه گیری فرآیند  وجود ندارد</p>
          </center>
          <table v-show="all_items.length" class="table table-striped">
            <thead>
            <tr>
              <th>ردیف</th>
              <th>کد شاخص فرآیند</th>
              <th>شرح شاخص </th>
              <th>مطلوبیت</th>
              <th>نوع شاخص</th>
              <th>مسئول پايش/ اندازه‏ گيري</th>
              <th>  عملکرد و مقایسه  </th>
              <th>جزئیات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in all_items">
              <td scope="row">{{index+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.description}}</td>
              <td>{{item.desirability}}</td>
              <td>{{item.type}}</td>
              <td>{{item.monitoring_processes.name}}</td>
              <td>
                <center>
                  <button class="btn btn-primary btn-submit-1" @click.prevent="PerformanceandComparisonMethod(item.id)">
                    عملکرد و مقایسه
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button class="btn btn-primary btn-submit-1" @click.prevent="showDetail(item.id)">
                   جزئیات
                  </button>
                </center>
              </td>



            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- ************************************** -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 67%;">
    <div>
      <p>مسئول پایش </p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input v-model="inserterId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['id'] }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod(item_id)">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter2"
       style="z-index: 999999999999999999999999999999999999999999999; top: 67%;">
    <div>
      <p>مالک شاخص </p>
      <p @click="select_inserter2=!select_inserter2">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization2" :key="item.id">
          <td scope="row"><input v-model="inserterId2" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['id'] }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod2">تایید</button>
    </div>
  </div>


  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter3"
       style="z-index: 999999999999999999999999999999999999999999999; top: 67%;">
    <div>
      <p>مسئول تایید شاخص </p>
      <p @click="select_inserter3=!select_inserter3">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization3" :key="item.id">
          <td scope="row"><input v-model="inserterId3" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['id'] }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod3">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 28%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="PerformanceandComparisonModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 68%;">
    <div>
      <p> عملکرد و مقایسه </p>
      <p @click="PerformanceandComparisonModal=!PerformanceandComparisonModal">❌</p>
    </div>
    <div>
      <p class="text-center w-100 bg-info text-white border-radius-20 p-1">عملکرد</p>

    <div class="row">
      <div class=" col-2 d-flex flex-column">
        <label>1397</label>
        <input disabled v-model="PerformanceVal1" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1398</label>
        <input disabled v-model="PerformanceVal2" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1399</label>
        <input disabled v-model="PerformanceVal3" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1400</label>
        <input disabled v-model="PerformanceVal4" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1401</label>
        <input disabled v-model="PerformanceVal5" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1402</label>
        <input disabled v-model="PerformanceVal6" type="number" class="form-control">
      </div>
    </div>
      <br>
      <p class="text-center w-100 bg-info text-white border-radius-20 p-1">مقایسه</p>
    <div class="row">
      <div class=" col-2 d-flex flex-column">
        <label>1397</label>
        <input disabled v-model="comparisonVal1" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1398</label>
        <input disabled v-model="comparisonVal2" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1399</label>
        <input disabled v-model="comparisonVal3" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1400</label>
        <input disabled v-model="comparisonVal4" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1401</label>
        <input disabled v-model="comparisonVal5" type="number" class="form-control">
      </div>
      <div class=" col-2 d-flex flex-column">
        <label>1402</label>
        <input disabled v-model="comparisonVal6" type="number" class="form-control">
      </div>
    </div>



     <div class="d-flex my-5">
       <button class="btn btn-primary btn-back m-2" @click="PerformanceandComparisonModal=!PerformanceandComparisonModal">بازگشت</button>

     </div>
    </div>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="detailModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 62%;">
    <div>
      <p> جزئیات </p>
      <p @click="detailModal=!detailModal">❌</p>
    </div>
    <div>
      <div class="bg-white w-100 p-2" style="border-radius: 1vw">
        <div >
          <div class="d-flex flex-nowrap"><p>شرح شاخص   :</p><p>{{detail[0]?.description}}</p></div>
          <div class="d-flex flex-nowrap"><p>کد شاخص:</p><p>{{detail[0]?.code}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p>مظلوبیت  :</p><p>{{detail[0]?.desirability}}</p></div>
          <div class="d-flex flex-nowrap"><p> نوع شاخص    :</p><p>{{detail[0]?.type}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p>مسئول پایش/اندازه گیری  :</p><p>{{detail[0]?.monitoring_processes.name}}</p></div>
          <div class="d-flex flex-nowrap"><p> مسئول    شاخص  :</p><p>{{detail[0]?.owner_organizationposts.name}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p>مسئول تایید شاخص  :</p><p>{{detail[0]?.seconder_organizationposts.name}}</p></div>
          <div class="d-flex flex-nowrap"><p> اهمیت    شاخص  :</p><p>{{detail[0]?.importance}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p>واحد سنجش  :</p><p>{{detail[0]?.unit }}</p></div>
          <div class="d-flex flex-nowrap"><p> فرمول محاسبه  :</p><p>{{detail[0]?.formula}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p>مبنای مقایسه    :</p><p>{{detail[0]?.base_of_comparison}}</p></div>
          <div class="d-flex flex-nowrap"><p> حداقل مجاز    :</p><p>{{detail[0]?.min}}</p></div>
        </div>
        <div >
          <div class="d-flex flex-nowrap"><p> حداکثر مجاز    :</p><p>{{detail[0]?.max}}</p></div>
        </div>
      </div>


      <button @click="detailModal=!detailModal">بازگشت</button>
    </div>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%;">
    <div>
      <p> خطا </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{ errorMessage }}


      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";

export default {
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      all_inserter: [],
      all_inserter2: [],
      all_inserter3: [],
      select_inserter: false,
      select_inserter2: false,
      select_inserter3: false,
      deleteModal: false,
      editModal: false,
      detailModal: false,
      PerformanceandComparisonModal: false,
      search_inserter: '',
      inserterId: '',
      inserterId2: '',
      inserterId3: '',
      inserterName: '',
      inserterNam2: '',
      inserterNam3: '',
      title: '',
      time: '',
      frequency: '',
      prerequisite: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,
      code: '',
      description: '',
      desirability: '',
      type: '',
      importance: '',
      unit: '',
      formula: '',
      base_of_comparison: '',
      min: '',
      max: '',
      PerformanceVal1: '',
      PerformanceVal2: '',
      PerformanceVal3: '',
      PerformanceVal4: '',
      PerformanceVal5: '',
      PerformanceVal6: '',
      comparisonVal1: '',
      comparisonVal2: '',
      comparisonVal3: '',
      comparisonVal4: '',
      comparisonVal5: '',
      comparisonVal6: '',
      detail: [],

    }
  },


  methods: {
    showDetail(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            this.detail.length=0
            if (item) {
              this.detailModal=true
              this.detail.push(item)
              /*this.code = item.code
              this.description = item.description
              this.desirability = item.desirability
              this.type = item.type
              this.type = item.type
              this.importance = item.importance
              this.unit = item.unit
              this.formula = item.formula
              this.base_of_comparison = item.base_of_comparison
              this.min = item.min
              this.max = item.max
              this.inserterName = item.monitoring_processes.name
              this.inserterId = item.monitoring_processes.id
              this.inserterNam2 = item.owner_organizationposts.name
              this.inserterId2 = item.owner_organizationposts.id
              this.inserterNam3 = item.seconder_organizationposts.name
              this.inserterId3 = item.seconder_organizationposts.id*/

            }


          })
          .catch();
    },
    PerformanceandComparisonMethodSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      let obj1 = [
        {
          'year': 1397,
          'value': this.PerformanceVal1
        } ,
        {
          'year': 1398,
          'value': this.PerformanceVal2
        },{
          'year': 1399,
          'value': this.PerformanceVal3
        },{
          'year': 1400,
          'value': this.PerformanceVal4
        },{
          'year': 1401,
          'value': this.PerformanceVal5
        },{
          'year': 1402,
          'value': this.PerformanceVal6
        },
      ]
      let obj2 = [
        {
          'year': 1397,
          'value': this.comparisonVal1
        } ,
        {
          'year': 1398,
          'value': this.comparisonVal2
        },{
          'year': 1399,
          'value': this.comparisonVal3
        },{
          'year': 1400,
          'value': this.comparisonVal4
        },{
          'year': 1401,
          'value': this.comparisonVal5
        },{
          'year': 1402,
          'value': this.comparisonVal6
        },
      ]

      formdata.append('comparison', JSON.stringify(obj1))
      formdata.append('functions',JSON.stringify(obj2))



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/add_other/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.PerformanceVal1=''
            this.PerformanceVal2=''
            this.PerformanceVal3=''
            this.PerformanceVal4=''
            this.PerformanceVal5=''
            this.PerformanceVal6=''
            this.comparisonVal1=''
            this.comparisonVal2=''
            this.comparisonVal3=''
            this.comparisonVal4=''
            this.comparisonVal5=''
            this.comparisonVal6=''
            this.PerformanceandComparisonModal = false



          })
          .catch();

    },
    PerformanceandComparisonMethod(id){
      this.PerformanceVal1=''
      this.PerformanceVal2=''
      this.PerformanceVal3=''
      this.PerformanceVal4=''
      this.PerformanceVal5=''
      this.PerformanceVal6=''
      this.comparisonVal1=''
      this.comparisonVal2=''
      this.comparisonVal3=''
      this.comparisonVal4=''
      this.comparisonVal5=''
      this.comparisonVal6=''
      this.item_id = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();





      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/show_other/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
         response.comparison.forEach((ele)=>{
           let year = parseInt(ele.year)
           if (year===1397){
             this.PerformanceVal1 = ele.value


           } if (year===1398){
             this.PerformanceVal2 = ele.value

           } if (year===1399){
             this.PerformanceVal3 = ele.value

           } if (year===1400){
             this.PerformanceVal4 = ele.value

           } if (year===1401){
             this.PerformanceVal5 = ele.value

           } if (year===1402){
             this.PerformanceVal6 = ele.value

           }
         })
            response.function.forEach((ele)=>{
           let year = parseInt(ele.year)
           if (year===1397){
             this.comparisonVal1 = ele.value


           } if (year===1398){
             this.comparisonVal2 = ele.value

           } if (year===1399){
             this.comparisonVal3 = ele.value

           } if (year===1400){
             this.comparisonVal4 = ele.value

           } if (year===1401){
             this.comparisonVal5 = ele.value

           } if (year===1402){
             this.comparisonVal6 = ele.value

           }
         })





          })
          .catch();
      this.PerformanceandComparisonModal = true

    },
    deleteModalMethod(id) {
      this.item_id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal = false


          })
          .catch();
    },
    edit(id) {
      this.item_id = id
      this.editModal = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item) {
              this.code = item.code
              this.description = item.description
              this.desirability = item.desirability
              this.type = item.type
              this.type = item.type
              this.importance = item.importance
              this.unit = item.unit
              this.formula = item.formula
              this.base_of_comparison = item.base_of_comparison
              this.min = item.min
              this.max = item.max
              this.inserterName = item.monitoring_processes.name
              this.inserterId = item.monitoring_processes.id
              this.inserterNam2 = item.owner_organizationposts.name
              this.inserterId2 = item.owner_organizationposts.id
              this.inserterNam3 = item.seconder_organizationposts.name
              this.inserterId3 = item.seconder_organizationposts.id

            }


          })
          .catch();
    },
    update(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      /*formdata.append('monitoring_processes_id', this.inserterId)
      formdata.append('owner_organizationposts_id', this.inserterId2)
      formdata.append('seconder_organizationposts_id', this.inserterId3)*/
      formdata.append('code', this.code)
      formdata.append('description', this.description)
      formdata.append('desirability', this.desirability)
      formdata.append('type', this.type)
      formdata.append('importance', this.importance)
      formdata.append('unit', this.unit)
      formdata.append('formula', this.formula)
      formdata.append('base_of_comparison', this.base_of_comparison)
      formdata.append('min', this.min)
      formdata.append('max', this.max)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId = ''
             this.inserterName = ''
            this.editModal = false
            this.code = ''
            this.description = ''
            this.desirability = ''
            this.type = ''
            this.importance = ''
            this.unit = ''
            this.formula = ''
            this.base_of_comparison = ''
            this.min = ''
            this.max = ''

            this.inserterName = ''
            this.inserterId = ''


          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      formdata.append('monitoring_organizationposts_id', this.inserterId)
      formdata.append('owner_organizationposts_id', this.inserterId2)
      formdata.append('seconder_organizationposts_id', this.inserterId3)
      formdata.append('processes_id', this.id_route)
      formdata.append('code', this.code)
      formdata.append('description', this.description)
      formdata.append('desirability', this.desirability)
      formdata.append('type', this.type)
      formdata.append('importance', this.importance)
      formdata.append('unit', this.unit)
      formdata.append('formula', this.formula)
      formdata.append('base_of_comparison', this.base_of_comparison)
      formdata.append('min', this.min)
      formdata.append('max', this.max)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId3 = ''
            this.inserterId2 = ''
            this.inserterNam3 = ''
            this.inserterNam2 = ''
            this.editModal = false
            this.code = ''
            this.description = ''
            this.desirability = ''
            this.type = ''
            this.importance = ''
            this.unit = ''
            this.formula = ''
            this.base_of_comparison = ''
            this.min = ''
            this.max = ''

            this.inserterName = ''
            this.inserterId = ''

          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************

    showListInserter() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)

              })
              this.select_inserter = true

            }

          })
          .catch();
    }, showListInserter2() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter2.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter2.push(item)

              })

              this.select_inserter2 = true
            }

          })
          .catch();
    },
    showListInserter3() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter3.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter3.push(item)

              })
              this.select_inserter3 = true

            }

          })
          .catch();
    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.all_items.length = 0
              response.all.forEach((item) => {
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },
    select_inserterMethod() {
      this.all_inserter.forEach((item) => {
        console.log(item)
        item.id === this.inserterId ? this.inserterName = item.name : ''

      })


      this.select_inserter = false


    }, select_inserterMethod2() {
      this.all_inserter2.forEach((item) => {
        item.id === this.inserterId2 ? this.inserterNam2 = item.name : ''

      })


      this.select_inserter2 = false


    }, select_inserterMethod3() {
      this.all_inserter2.forEach((item) => {
        item.id === this.inserterId3 ? this.inserterNam3 = item.name : ''

      })

      this.select_inserter3 = false


    },


  },

  computed: {

     filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    }, filteredorganization2() {
      return this.all_inserter2.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    }, filteredorganization3() {
      return this.all_inserter3.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  }

}

</script>

<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>